import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

// Locale
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';

// Rutas
import { APP_ROUTES } from './app-routes.module';

// Modulos
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';

// Components
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './authentication/notfound/not-found.component';
import { LoginComponent } from './authentication/login/login.component';
import { RegisterComponent } from './authentication/register/register.component';
import { LockComponent } from './authentication/lock/lock.component';
import { HomeComponent } from './pages/home/home.component';
import { CheckboxEditorComponent } from './custom-components/cell-editor/checkbox-editor.component';
import { SelectEditorComponent } from './custom-components/cell-editor/select-editor.component';
import { TextEditorComponent } from './custom-components/cell-editor/text-editor.component';
import { NumericEditorComponent } from './custom-components/cell-editor/numeric-editor.component';

// Configuracion
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgbdAlertBasicComponent } from './custom-components/alert/alert.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    LoginComponent,
    HomeComponent,
    NotFoundComponent,
    RegisterComponent,
    LockComponent,
    NgbdAlertBasicComponent,
    CheckboxEditorComponent,
    SelectEditorComponent,
    NumericEditorComponent,
    TextEditorComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    RouterModule.forRoot(APP_ROUTES, { useHash: true }),
    PerfectScrollbarModule,
    NgxSpinnerModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyBUb3jDWJQ28vDJhuQZxkC0NXr_zycm8D0' })
  ],
  providers: [
    { provide: LOCALE_ID, useValue : 'es-MX' },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    CheckboxEditorComponent,
    SelectEditorComponent,
    NumericEditorComponent,
    TextEditorComponent
  ]
})
export class AppModule {}

